import { IonIcon } from '@ionic/react';
import { duplicateOutline } from 'ionicons/icons';
import { LinkTo } from '../atoms/LinkTo';

interface Props {
  index: number;
  data: Record<any, any>;
  path: string;
}

export const CloneEntityButton = ({ index, data, path }: Props) => {
  return (
    <div style={{ position: 'absolute', bottom: 10, right: 6 }}>
      <LinkTo link={`${path}/${data?.id}`} data={data} testId={`clone_${index}`}>
        <IonIcon icon={duplicateOutline} style={{ fontSize: 18 }} color="dark"></IonIcon>
      </LinkTo>
    </div>
  );
};
